/**
 * @generated SignedSource<<1e705a2cc9edb86affeea1d0102a8f32>>
 * @relayHash 03405d83b15f59d0889abdb0c63674a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138

import type { ConcreteRequest } from 'relay-runtime';
export type useBridge_tenantUserQuery$variables = {
  cloudIds?: ReadonlyArray<string> | null | undefined;
};
export type useBridge_tenantUserQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudUrl: AGG$URL | null | undefined;
  } | null | undefined> | null | undefined;
};
export type useBridge_tenantUserQuery = {
  response: useBridge_tenantUserQuery$data;
  variables: useBridge_tenantUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "cloudUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useBridge_tenantUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBridge_tenantUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138",
    "metadata": {},
    "name": "useBridge_tenantUserQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "608300bf42cc1b2188141c51b357201e";

export default node;
